
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as _91id_931veVtVMtOGumtYjUMrHluhHBX0rd59GU1SRflUlekBYMeta } from "/app/pages/cc/[id].vue?macro=true";
import { default as _91id_93qzl1yHuFB4IAoR24DS33hLCwIcjrIXg1HMnqBxviwZ8Meta } from "/app/pages/wh/[id].vue?macro=true";
import { default as indexVbTqsRZ8ivU0twVLNNQVr2sJSPa1OLi2oeqFWQlQ3hQMeta } from "/app/pages/cc/index.vue?macro=true";
import { default as _91id_93Ft7nouQPgfpSonfS5S0ELkPMOkLysY9jnc0AulBixbcMeta } from "/app/pages/faq/[id].vue?macro=true";
import { default as indexwYoDzJ9YtWZdsgEjIVBrfcwEh2XF3oYpePC3hg2EmRwMeta } from "/app/pages/wh/index.vue?macro=true";
import { default as _91id_93TI3C61KgW6dqAjE7_458LERoTUfKIXqirvTcuz17jHCfkMeta } from "/app/pages/users/[id].vue?macro=true";
import { default as indexQ2XknYyc5pBDpRzn9udkDp9sYEpRAWu7uB5__WEvmxIMeta } from "/app/pages/files/index.vue?macro=true";
import { default as indexkFvFao0mf7UN3hyJuK0wU7vluZ7uf39m_45YUtyJJyVocMeta } from "/app/pages/leads/index.vue?macro=true";
import { default as _91id_93m2dan2BEfTEPFV3c776HiTaMQPNNdM6hpCfjNa3UUpgMeta } from "/app/pages/offers/[id].vue?macro=true";
import { default as _91id_93z_45mKuW1rMZYIKaD_45jb7RkOPiwtU5vi28dxEw6FTfUakMeta } from "/app/pages/orders/[id].vue?macro=true";
import { default as _91id_93MOpIBGSklMB4peGcVSrp84TSYMiaVusz8WszN1_45iKTIMeta } from "/app/pages/stores/[id].vue?macro=true";
import { default as indexwqqxPBLNl0Gqxy2G7X4gCBzRids0_eE4yk9P0pmntIkMeta } from "/app/pages/users/index.vue?macro=true";
import { default as _91id_93Y_WAEkZ4azLvIPwNNpUfh0vS6PL9wvp4novfFRRXw_45kMeta } from "/app/pages/brokers/[id].vue?macro=true";
import { default as index9fStvmnJX7wtyuxF4J9xpemZtShahA8HONjn9_45myOpUMeta } from "/app/pages/offers/index.vue?macro=true";
import { default as indexDCqhPzutOZTeEBErhbpXyxz9LSZCrOqFoLSpaIOOmIIMeta } from "/app/pages/orders/index.vue?macro=true";
import { default as indexv46crOPEOD1SXWkWSW_45c6zJmxY7RF9_45TCFlqQM21EmIMeta } from "/app/pages/stocks/index.vue?macro=true";
import { default as indexjFmzYCPIk6f4UlvnZvPTtviub1WyjSyUq0Na3e9mLbMMeta } from "/app/pages/stores/index.vue?macro=true";
import { default as unauthorized17NYwdK_vpXoMmVXmhdTSn6CG_AM5wMHLBy01ScJbgcMeta } from "/app/pages/unauthorized.vue?macro=true";
import { default as indexLGTKDYdfggNUkwlQulqc8QtZVmb7vqsrBNXxlT8xP8UMeta } from "/app/pages/brokers/index.vue?macro=true";
import { default as _91id_93_45PE2AxgFD2RwGb9NHm6_13JnEUmqK_tkTe8tgKEfNtoMeta } from "/app/pages/cc/teams/[id].vue?macro=true";
import { default as _91id_93TZdc7ql2AIXFjklp3g3sE9H4i7CcLHcpno8_y3KdL_45kMeta } from "/app/pages/campaigns/[id].vue?macro=true";
import { default as indexvECqT1vBFCPFMuVwZFVmBMZJPNUZv9U255MbufRd1zsMeta } from "/app/pages/cc/teams/index.vue?macro=true";
import { default as indexwmUbDH_o9WDxQRlkBzvT4fzPE0mga67obVz2Uc_452UYsMeta } from "/app/pages/holdings/index.vue?macro=true";
import { default as indexCS9TBWZLvVvHfBzyOBaud5vfuMt23eSrxLSN_ubukeEMeta } from "/app/pages/products/index.vue?macro=true";
import { default as indexBJksL39rx5cUc1Ib_m_457evzX_LojTj9_45lIMClMEmOVkMeta } from "/app/pages/campaigns/index.vue?macro=true";
import { default as _91id_93xu4AGGaAF7_oCr6MlGgeOVm09ZlXOFSEFhUG10jAOlgMeta } from "/app/pages/publishers/[id].vue?macro=true";
import { default as indexVhKslFYp_45mTfHjJnlOXkLEXcKIKBNblS1mS7Wqxi_WAMeta } from "/app/pages/publishers/index.vue?macro=true";
import { default as indexlFqzACGZENnG_W_DXi0cwsiRrGw3cXkqdbr1FV6nq7UMeta } from "/app/pages/stats/orders/index.vue?macro=true";
import { default as indexqZuNeHyqb8FrMxhKpSDWOrog4_Rln5v2USDuEf4T3KIMeta } from "/app/pages/products/[id]/index.vue?macro=true";
import { default as _91id_937qYdRun6vi3N4oQD4Wy1e_Ljtt01jS3mLeuXW6ywWv8Meta } from "/app/pages/brokers/configs/[id].vue?macro=true";
import { default as indextx88hi1xZ5firf22vqJNonO1scBgMhYDxPNcejGaqnoMeta } from "/app/pages/stats/holdings/index.vue?macro=true";
import { default as _91id_93PMFuHqp_458moUW4tQlXJDEV7PxlWyBLqSOBIlRuK79nkMeta } from "/app/pages/publishers/teams/[id].vue?macro=true";
import { default as indexM5Yoc216euziCoXgKQvsW4nyPhigoyCp8bYtVWfnaokMeta } from "/app/pages/publishers/teams/index.vue?macro=true";
import { default as _91variantId_93ViyIBxtEGYTzlyXG0ySoxRhWFwm0OGveC00eBd9fDdMMeta } from "/app/pages/products/[id]/variants/[variantId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "cc-id",
    path: "/cc/:id()",
    meta: _91id_931veVtVMtOGumtYjUMrHluhHBX0rd59GU1SRflUlekBYMeta || {},
    component: () => import("/app/pages/cc/[id].vue")
  },
  {
    name: "wh-id",
    path: "/wh/:id()",
    meta: _91id_93qzl1yHuFB4IAoR24DS33hLCwIcjrIXg1HMnqBxviwZ8Meta || {},
    component: () => import("/app/pages/wh/[id].vue")
  },
  {
    name: "cc",
    path: "/cc",
    meta: indexVbTqsRZ8ivU0twVLNNQVr2sJSPa1OLi2oeqFWQlQ3hQMeta || {},
    component: () => import("/app/pages/cc/index.vue")
  },
  {
    name: "faq-id",
    path: "/faq/:id()",
    meta: _91id_93Ft7nouQPgfpSonfS5S0ELkPMOkLysY9jnc0AulBixbcMeta || {},
    component: () => import("/app/pages/faq/[id].vue")
  },
  {
    name: "wh",
    path: "/wh",
    meta: indexwYoDzJ9YtWZdsgEjIVBrfcwEh2XF3oYpePC3hg2EmRwMeta || {},
    component: () => import("/app/pages/wh/index.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    meta: _91id_93TI3C61KgW6dqAjE7_458LERoTUfKIXqirvTcuz17jHCfkMeta || {},
    component: () => import("/app/pages/users/[id].vue")
  },
  {
    name: "files",
    path: "/files",
    meta: indexQ2XknYyc5pBDpRzn9udkDp9sYEpRAWu7uB5__WEvmxIMeta || {},
    component: () => import("/app/pages/files/index.vue")
  },
  {
    name: "leads",
    path: "/leads",
    meta: indexkFvFao0mf7UN3hyJuK0wU7vluZ7uf39m_45YUtyJJyVocMeta || {},
    component: () => import("/app/pages/leads/index.vue")
  },
  {
    name: "offers-id",
    path: "/offers/:id()",
    meta: _91id_93m2dan2BEfTEPFV3c776HiTaMQPNNdM6hpCfjNa3UUpgMeta || {},
    component: () => import("/app/pages/offers/[id].vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    meta: _91id_93z_45mKuW1rMZYIKaD_45jb7RkOPiwtU5vi28dxEw6FTfUakMeta || {},
    component: () => import("/app/pages/orders/[id].vue")
  },
  {
    name: "stores-id",
    path: "/stores/:id()",
    meta: _91id_93MOpIBGSklMB4peGcVSrp84TSYMiaVusz8WszN1_45iKTIMeta || {},
    component: () => import("/app/pages/stores/[id].vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexwqqxPBLNl0Gqxy2G7X4gCBzRids0_eE4yk9P0pmntIkMeta || {},
    component: () => import("/app/pages/users/index.vue")
  },
  {
    name: "brokers-id",
    path: "/brokers/:id()",
    meta: _91id_93Y_WAEkZ4azLvIPwNNpUfh0vS6PL9wvp4novfFRRXw_45kMeta || {},
    component: () => import("/app/pages/brokers/[id].vue")
  },
  {
    name: "offers",
    path: "/offers",
    meta: index9fStvmnJX7wtyuxF4J9xpemZtShahA8HONjn9_45myOpUMeta || {},
    component: () => import("/app/pages/offers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexDCqhPzutOZTeEBErhbpXyxz9LSZCrOqFoLSpaIOOmIIMeta || {},
    component: () => import("/app/pages/orders/index.vue")
  },
  {
    name: "stocks",
    path: "/stocks",
    meta: indexv46crOPEOD1SXWkWSW_45c6zJmxY7RF9_45TCFlqQM21EmIMeta || {},
    component: () => import("/app/pages/stocks/index.vue")
  },
  {
    name: "stores",
    path: "/stores",
    meta: indexjFmzYCPIk6f4UlvnZvPTtviub1WyjSyUq0Na3e9mLbMMeta || {},
    component: () => import("/app/pages/stores/index.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/app/pages/unauthorized.vue")
  },
  {
    name: "brokers",
    path: "/brokers",
    meta: indexLGTKDYdfggNUkwlQulqc8QtZVmb7vqsrBNXxlT8xP8UMeta || {},
    component: () => import("/app/pages/brokers/index.vue")
  },
  {
    name: "cc-teams-id",
    path: "/cc/teams/:id()",
    meta: _91id_93_45PE2AxgFD2RwGb9NHm6_13JnEUmqK_tkTe8tgKEfNtoMeta || {},
    component: () => import("/app/pages/cc/teams/[id].vue")
  },
  {
    name: "campaigns-id",
    path: "/campaigns/:id()",
    meta: _91id_93TZdc7ql2AIXFjklp3g3sE9H4i7CcLHcpno8_y3KdL_45kMeta || {},
    component: () => import("/app/pages/campaigns/[id].vue")
  },
  {
    name: "cc-teams",
    path: "/cc/teams",
    meta: indexvECqT1vBFCPFMuVwZFVmBMZJPNUZv9U255MbufRd1zsMeta || {},
    component: () => import("/app/pages/cc/teams/index.vue")
  },
  {
    name: "holdings",
    path: "/holdings",
    meta: indexwmUbDH_o9WDxQRlkBzvT4fzPE0mga67obVz2Uc_452UYsMeta || {},
    component: () => import("/app/pages/holdings/index.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indexCS9TBWZLvVvHfBzyOBaud5vfuMt23eSrxLSN_ubukeEMeta || {},
    component: () => import("/app/pages/products/index.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    meta: indexBJksL39rx5cUc1Ib_m_457evzX_LojTj9_45lIMClMEmOVkMeta || {},
    component: () => import("/app/pages/campaigns/index.vue")
  },
  {
    name: "publishers-id",
    path: "/publishers/:id()",
    meta: _91id_93xu4AGGaAF7_oCr6MlGgeOVm09ZlXOFSEFhUG10jAOlgMeta || {},
    component: () => import("/app/pages/publishers/[id].vue")
  },
  {
    name: "publishers",
    path: "/publishers",
    meta: indexVhKslFYp_45mTfHjJnlOXkLEXcKIKBNblS1mS7Wqxi_WAMeta || {},
    component: () => import("/app/pages/publishers/index.vue")
  },
  {
    name: "stats-orders",
    path: "/stats/orders",
    meta: indexlFqzACGZENnG_W_DXi0cwsiRrGw3cXkqdbr1FV6nq7UMeta || {},
    component: () => import("/app/pages/stats/orders/index.vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    meta: indexqZuNeHyqb8FrMxhKpSDWOrog4_Rln5v2USDuEf4T3KIMeta || {},
    component: () => import("/app/pages/products/[id]/index.vue")
  },
  {
    name: "brokers-configs-id",
    path: "/brokers/configs/:id()",
    meta: _91id_937qYdRun6vi3N4oQD4Wy1e_Ljtt01jS3mLeuXW6ywWv8Meta || {},
    component: () => import("/app/pages/brokers/configs/[id].vue")
  },
  {
    name: "stats-holdings",
    path: "/stats/holdings",
    meta: indextx88hi1xZ5firf22vqJNonO1scBgMhYDxPNcejGaqnoMeta || {},
    component: () => import("/app/pages/stats/holdings/index.vue")
  },
  {
    name: "publishers-teams-id",
    path: "/publishers/teams/:id()",
    meta: _91id_93PMFuHqp_458moUW4tQlXJDEV7PxlWyBLqSOBIlRuK79nkMeta || {},
    component: () => import("/app/pages/publishers/teams/[id].vue")
  },
  {
    name: "publishers-teams",
    path: "/publishers/teams",
    meta: indexM5Yoc216euziCoXgKQvsW4nyPhigoyCp8bYtVWfnaokMeta || {},
    component: () => import("/app/pages/publishers/teams/index.vue")
  },
  {
    name: "products-id-variants-variantId",
    path: "/products/:id()/variants/:variantId()",
    meta: _91variantId_93ViyIBxtEGYTzlyXG0ySoxRhWFwm0OGveC00eBd9fDdMMeta || {},
    component: () => import("/app/pages/products/[id]/variants/[variantId].vue")
  }
]